export * from './UIGameTradeOfferHeader.tsx';
